import columns from '../../../../../../react-table/helpers/columns';
import { sumTotal } from '../../../../../../react-table/helpers/rowTotals';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_DETAILS.id,
    mainReportId: ReportDefinitions.PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_SUMMARY.id,
    requestParams: {
      impcFrom: rowInfo.row['originImpc.code'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: 'Origin IMPC',
      columns: [
        new TextColumn('Operator', 'originImpc.operator'),
        new TextColumn('Code', 'originImpc.code').withTotalHeader('Total'),
      ],
    },
    {
      Header: '',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('Despatches', 'despatches').withTotalHeader(sumTotal), getDetailsTabNavOptions),
      ],
    },
    {
      Header: 'Receptacle scan - planned arrival (hours)',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('<= Planned', 'scanVsPlanning.withinPlan').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('<= 2', 'scanVsPlanning.missedBy2h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('> 2 <= 6', 'scanVsPlanning.missedBy2to6h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('> 6 <= 24', 'scanVsPlanning.missedBy6to24h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('> 24 <= 48', 'scanVsPlanning.missedBy24to48h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('> 48 <= 72', 'scanVsPlanning.missedBy48to72h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('> 72', 'scanVsPlanning.missedByMoreThan72h').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('No arrival date', 'scanVsPlanning.noArrivalDate').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Not scanned', 'scanVsPlanning.notScanned').withTotalHeader(sumTotal), getDetailsTabNavOptions),
      ],
    },
    {
      Header: 'Max tail',
      columns: [
        new NonZeroNumberColumn('d', 'maxTail.missedDay'),
        new NonZeroNumberColumn('h', 'maxTail.missedHour'),
        new NonZeroNumberColumn('m', 'maxTail.missedMinute'),
      ],
    },
  ];
};
